import { useMutation } from '@tanstack/react-query';

import {
  AdminFonctionnelControllerApi,
  UpdateDonneesJudiciairesViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import {
  ControllerApi,
  UpdateDonneesJudiciairesFormValues,
  ValidateFunction,
} from './types';
import { buildUpdateDonneesJudiciairesDto } from './utils';

function useValidateUpdateDonneesJudiciaires(
  controller: ControllerApi,
  dossierId: string,
): ValidateFunction {
  const mutation = useMutation({
    mutationFn: async ({
      field,
      formValues,
    }: {
      field: UpdateDonneesJudiciairesViolationDtoFormFieldEnum;
      formValues: UpdateDonneesJudiciairesFormValues;
    }) => {
      const params = buildUpdateDonneesJudiciairesDto(formValues);

      const response = await getValidateUpdateDonneesJudiciairesField(
        controller,
      )(field, dossierId, params);

      const violations =
        response.updateDonneesJudiciairesViolationDtoList ?? [];

      if (violations.length === 0) {
        return Promise.resolve();
      }

      return Promise.reject(violations[0].message);
    },
    mutationKey: ['validate-update-donnees-judiciaires-field', dossierId],
  });

  return {
    validateFields: async (
      field: UpdateDonneesJudiciairesViolationDtoFormFieldEnum,
      formValues: UpdateDonneesJudiciairesFormValues,
    ): Promise<void> => {
      await mutation.mutateAsync({ field, formValues });
    },
  };
}

export function isInstanceOfAdminFonctionnel(
  controller: ControllerApi,
): controller is AdminFonctionnelControllerApi {
  return controller instanceof AdminFonctionnelControllerApi;
}

function getValidateUpdateDonneesJudiciairesField(controller: ControllerApi) {
  if (isInstanceOfAdminFonctionnel(controller)) {
    return controller.validateUpdateDonneesJudiciairesFieldUsingPOST1.bind(
      controller,
    );
  }
  return controller.validateUpdateDonneesJudiciairesFieldUsingPOST.bind(
    controller,
  );
}

export default useValidateUpdateDonneesJudiciaires;
